const roleTranslation = {
  admin: "Administrador",
  pharmacies: "Farmacias",
  pharmagroups: "Grupos",
  distributors: "Distribuidores",
  super_admin: "Super admin",
  commertial: "Comercial",
  asistente: "Asistente",
  kam: "KAM",
  ges: "GES",
  medic: "Medico",
  consultant: "Visitador",
  full: "Full",
  traceability: "Trazabilidad",
  pharmacy_supervisor: "Sup.Farmacia",
  developer: "Desarrollador",
};

const reverseRoleTranslation = {
  Administrador: "admin",
  Farmacias: "pharmacies",
  Grupos: "pharmagroups",
  Distribuidores: "distributors",
  Superadmin: "super_admin",  // No whitespaces
  Comercial: "commertial",
  Asistente: "asistente",
  KAM: "kam",
  GES: "ges",
  Medico: "medic",
  Visitador: "consultant",
  Full: "full",
  Trazabilidad: "traceability",
  "Sup.Farmacia": "pharmacy_supervisor",
  Desarrollador: "developer",
};

// Roles that the admin cant see
const hidedRoles = new Set([
  "super_admin",
  // "kam",
  // "commertial",
  // "medic",
  // "consultant",
  // "ges",
  // "full",
  // "asistente",
  "Super admin",
  // "Comercial",
  // "asistente",
  // "KAM",
  // "GES",
  // "Medico",
  // "Visitador",
  // "Full",
]);

export { roleTranslation, hidedRoles, reverseRoleTranslation };
